//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ProductSimpleBaseView',
  props: {
    product: {
      default: () => { },
    },
    price: {
      default: '0.00',
    },
  },
  data() {
    return {
      currency: window.currency,
    }
  },
  computed: {
    getPercent() {
      return (oldPrice, newPrice) => {
        if (!oldPrice || !newPrice) return 0;
        const percent = ((oldPrice - newPrice) / oldPrice) * 100;
        return Math.round(percent);
      }
    },
  },
}
